import { ObservableArray, View } from "binder"
import { FileSelectorViewModel, ServerSideDataLoader } from "uicomponents";
import { MinBenefitPercentage, SetMinBenefitPercentageViewModel } from "./setMinBenefitPercentage-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class SetMinBenefitPercentageView extends View<SetMinBenefitPercentageViewModel>{
    GetViewUniqueId(): string {
        return "V-0EE788C6-83F7-4199-91EA-6B505312AD96"
    }
    loadHtml(): string {
        let element = require('./setMinBenefitPercentage.html').default;
        let style = require('./setMinBenefitPercentage.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set products(v: ObservableArray<MinBenefitPercentage>) { this._products = v; } public get products(): ObservableArray<MinBenefitPercentage> { return this._products;} private _products: ObservableArray<MinBenefitPercentage>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
     
    export() {
        this.dataContext.export();
    }
    
    import() {
        this.dataContext.import();
    }
    
    createMinBenefitPercentage() {
        this.dataContext.createMinBenefitPercentage();
    }
    
}
